export default __webpack_public_path__ + "static/media/sample.3ecbd8e1.png";